export default __webpack_public_path__ + "static/media/1 copy.10e54331.jpg";